import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'je-version',
    templateUrl: './version.component.html',
    standalone: true,
})
export class JeVersionComponent {
    public version = environment.version;
}
